<template>
  <div :class="$style.list">
    <header
      :class="[
        $style.list__header,
        $style.header,
        { [$style['header--editable']]: hasFavoriteFilteringRules },
      ]"
    >
      <p :class="$style.header__title">ユーザーを絞り込む</p>
      <FavoriteFilterRulesSelector
        v-model="selectedFavoriteFilteringRuleIndex"
        :rules="favoriteFilteringRulesRef"
        @select="loadFavoriteFilteringRule"
        @update="updateFavorite"
        @save="saveFavorite"
        @remove="removeFavorite"
      />
    </header>
    <ul :class="[$style.list__contents, $style.content]">
      <li :class="$style.content__item">
        <p :class="$style.content__text">ユーザーの流入元</p>
        <ul>
          <li
            :class="$style.radiobutton"
            v-for="(option, index) in channelOptions"
            :key="index"
          >
            <DolphinRadioButtonWithLabel
              name="channel"
              v-model="ruleRef.channel"
              :value="option.value"
            >
              {{ option.text }}
            </DolphinRadioButtonWithLabel>
          </li>
        </ul>
      </li>
      <li :class="$style.content__item">
        <p :class="$style.content__text">あなたのアプローチ状況</p>
        <ul>
          <li
            :class="$style.radiobutton"
            :key="option.value"
            v-for="option in answeredOptions"
          >
            <DolphinRadioButtonWithLabel
              name="hasAnswered"
              v-model="ruleRef.hasAnswered"
              :value="option.value"
            >
              {{ option.text }}
            </DolphinRadioButtonWithLabel>
          </li>
        </ul>
      </li>
      <li :class="$style.content__item">
        <p :class="$style.content__text">今悩んでいることの有無</p>
        <ul>
          <li
            :class="$style.radiobutton"
            :key="option.value"
            v-for="option in hasConcernOptions"
          >
            <DolphinRadioButtonWithLabel
              name="hasConcern"
              v-model="ruleRef.hasConcern"
              :value="option.value"
            >
              {{ option.text }}
            </DolphinRadioButtonWithLabel>
          </li>
        </ul>
      </li>
      <li :class="$style.content__item">
        <p :class="$style.content__text">年収</p>
        <DolphinRangeSelector
          :class="$style.content__range"
          :minOptions="minMillionUnitOptions"
          :maxOptions="maxMillionUnitOptions"
          v-model="ruleRef.annualIncome"
          minPlaceholder="下限なし"
          maxPlaceholder="上限なし"
          column
        />
      </li>
      <li :class="$style.content__item">
        <p :class="$style.content__text">預貯金</p>
        <DolphinRangeSelector
          :class="$style.content__range"
          :minOptions="minMillionUnitOptions"
          :maxOptions="maxMillionUnitOptions"
          v-model="ruleRef.saving"
          minPlaceholder="下限なし"
          maxPlaceholder="上限なし"
          column
        />
      </li>
      <li :class="$style.content__item">
        <p :class="$style.content__text">資産運用額</p>
        <DolphinRangeSelector
          :class="$style.content__range"
          :minOptions="minMillionUnitOptions"
          :maxOptions="maxMillionUnitOptions"
          v-model="ruleRef.investment"
          minPlaceholder="下限なし"
          maxPlaceholder="上限なし"
          column
        />
      </li>
      <li :class="$style.content__item">
        <div :class="[$style.content__text, $style.titleWithHelp]">
          <p>総資産額</p>
          <HelpPoptip :class="$style.titleWithHelp__help"
            ><p :class="$style.tip">預貯金と資産運用額の合計です</p></HelpPoptip
          >
        </div>
        <DolphinRangeSelector
          :class="$style.content__range"
          :minOptions="minMillionUnitOptions"
          :maxOptions="maxMillionUnitOptions"
          v-model="ruleRef.totalAssets"
          minPlaceholder="下限なし"
          maxPlaceholder="上限なし"
          column
        />
      </li>
      <li :class="$style.content__item">
        <p :class="$style.content__text">保険料</p>
        <DolphinRangeSelector
          :class="$style.content__range"
          :minOptions="minTenThousandUnitOptions"
          :maxOptions="maxTenThousandUnitOptions"
          v-model="ruleRef.monthlyInsuranceFee"
          minPlaceholder="下限なし"
          maxPlaceholder="上限なし"
          column
        />
      </li>
      <li :class="$style.content__item">
        <p :class="$style.content__text">借り入れの合計額</p>
        <DolphinRangeSelector
          :class="$style.content__range"
          :minOptions="minMillionUnitOptions"
          :maxOptions="maxMillionUnitOptions"
          v-model="ruleRef.loanBalance"
          minPlaceholder="下限なし"
          maxPlaceholder="上限なし"
          column
        />
      </li>
      <li :class="[$style['content__item'], $style['address']]">
        <p :class="$style.content__text">住所</p>
        <DolphinSelector
          :class="$style.content__selector"
          v-model="ruleRef.prefecture"
          :options="prefectureCodeOptions"
          placeholder="指定なし"
        />
        <DolphinSelector
          :class="[$style.content__selector, $style['address__city']]"
          v-model="ruleRef.city"
          :options="cityOptions"
          :disabled="cityOptions.length === 0"
          placeholder="指定なし"
        />
      </li>
      <li :class="$style.content__item">
        <p :class="$style.content__text">配偶者有無</p>
        <ul>
          <li
            :class="$style.radiobutton"
            :key="option.value"
            v-for="option in hasPartnerOptions"
          >
            <DolphinRadioButtonWithLabel
              name="hasPartner"
              v-model="ruleRef.partnerExistence"
              :value="option.value"
            >
              {{ option.text }}
            </DolphinRadioButtonWithLabel>
          </li>
        </ul>
      </li>
      <li
        :class="[
          $style.content__item,
          $style.checkbox,
          {
            [$style['content--disabled']]:
              ruleRef.partnerExistence !== 'existPartner',
          },
        ]"
      >
        <p :class="$style.content__text">配偶者年収</p>
        <DolphinRangeSelector
          :class="$style.content__range"
          :minOptions="minMillionUnitOptions"
          :maxOptions="maxMillionUnitOptions"
          :disabled="ruleRef.partnerExistence !== 'existPartner'"
          v-model="ruleRef.partnerAnnualIncome"
          minPlaceholder="下限なし"
          maxPlaceholder="上限なし"
          column
        />
      </li>
      <li :class="$style.content__item">
        <p :class="$style.content__text">子供有無</p>
        <ul>
          <li
            :class="$style.radiobutton"
            :key="option.value"
            v-for="option in hasChildrenOptions"
          >
            <DolphinRadioButtonWithLabel
              name="hasChildren"
              v-model="ruleRef.childrenExistence"
              :value="option.value"
            >
              {{ option.text }}
            </DolphinRadioButtonWithLabel>
          </li>
        </ul>
      </li>
      <li :class="$style.content__item">
        <p :class="$style.content__text">本人年齢</p>
        <ul>
          <li :key="option.value" v-for="option in userGenerationOptions">
            <label :class="$style.selectable">
              <DolphinCheckbox
                v-model="ruleRef.generation"
                :value="option.value"
              />
              <p :class="$style.selectable__text">{{ option.text }}</p>
            </label>
          </li>
        </ul>
      </li>
      <li :class="$style.content__item">
        <p :class="$style.content__text">性別</p>
        <ul>
          <li
            :class="$style.radiobutton"
            :key="option.value"
            v-for="option in sexOptions"
          >
            <DolphinRadioButtonWithLabel
              name="sex"
              v-model="ruleRef.sex"
              :value="option.value"
            >
              {{ option.text }}
            </DolphinRadioButtonWithLabel>
          </li>
        </ul>
      </li>
      <li :class="$style.content__item">
        <p :class="$style.content__text">職業</p>
        <ul>
          <li :key="option.value" v-for="option in jobOptions">
            <label :class="$style.selectable">
              <DolphinCheckbox v-model="ruleRef.jobIds" :value="option.value" />
              <p :class="$style.selectable__text">{{ option.text }}</p>
            </label>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import fastDeepEqual from 'fast-deep-equal'
import { computed, watch } from 'vue'

import DolphinCheckbox from '@/components/atoms/DolphinCheckbox.vue'
import DolphinSelector from '@/components/atoms/DolphinSelector.vue'
import DolphinRangeSelector from '@/components/molecules/DolphinRangeSelector.vue'
import DolphinRadioButtonWithLabel from '@/components/molecules/DolphinRadioButtonWithLabel.vue'
import FavoriteFilterRulesSelector from './FavoriteFilterRulesSelector.vue'
import HelpPoptip from '@/components/molecules/HelpPoptip.vue'

import { PREFECTURE_CODES } from '@/features/prefecture/jisx0402'

import { emptyKarteUserFilteringRule } from '@/pages/KarteListPage/hooks/useKarteUserListFilterForm'
import { useKarteUserFilteringRule } from '../hooks/useKarteUserFilteringRule'
import type {
  KarteUserFilteringRuleForm,
  HasConcern,
  ChildrenExistence,
  PartnerExistence,
  Generation,
  Sex,
  HasAnswered,
  FormChannel,
  Prefecture,
  MillionUnit,
  TenThousandUnit,
  JobIds,
} from '../hooks/useKarteUserFilteringRule'
import { useAlert } from '@/libs/alertPortal'
import { Prefecture as PrefectureSchema } from '@/types/schema.generated'

import {
  type KarteUserFilteringRule,
  type OptionValueType,
  type Option,
  convertJisx0402CodeToGqlPrefecture,
  type Planner,
} from '@/types/app'
import {
  type ChannelItemOnkarteUserFilteringItemListFragment,
  useFetchCitiesOnKarteUserFilterItemListQuery,
  useKarteUserFilteringItemListQuery,
} from './KarteUserFilteringItemList.generated'
import { parsePlannerProfileResponseToPlanner } from '@/apis/repositories/parsers/planner.ts'

const alert = useAlert()

type FormOptions<T extends OptionValueType> = Option<T>[]

const hasChildrenOptions: FormOptions<ChildrenExistence> = [
  { value: 'notSelected', text: '指定なし' },
  { value: 'existChildren', text: 'あり' },
  { value: 'noChildren', text: 'なし' },
]

const hasPartnerOptions: FormOptions<PartnerExistence> = [
  { value: 'notSelected', text: '指定なし' },
  { value: 'existPartner', text: 'あり' },
  { value: 'noPartner', text: 'なし' },
]

const hasConcernOptions: FormOptions<HasConcern> = [
  { value: 'notSelected', text: '指定なし' },
  { value: 'existConcern', text: '記入あり' },
  { value: 'noConcern', text: '記入なし' },
]

const userGenerationOptions: FormOptions<Generation> = [
  { value: 0, text: '20代以下' },
  { value: 30, text: '30代' },
  { value: 40, text: '40代' },
  { value: 50, text: '50代' },
  { value: 60, text: '60代以上' },
]

const sexOptions: FormOptions<Sex> = [
  { value: 'notSelected', text: '指定なし' },
  { value: 'male', text: '男性' },
  { value: 'female', text: '女性' },
]

const answeredOptions: FormOptions<HasAnswered> = [
  { value: 'notSelected', text: '指定なし' },
  { value: 'answered', text: 'アプローチ済み' },
  { value: 'notAnswered', text: '未アプローチ' },
]

const jobOptions: FormOptions<JobIds> = [
  { value: 1, text: '会社員（上場企業）' },
  { value: 2, text: '会社員（その他）' },
  { value: 3, text: '経営者・会社役員' },
  { value: 4, text: '公務員' },
  { value: 5, text: '自営業' },
  { value: 6, text: '士業（弁護士・会計士等）' },
  { value: 7, text: '医療従事者' },
  { value: 8, text: '契約社員・派遣社員・業務委託' },
  { value: 9, text: 'パート・アルバイト' },
  { value: 10, text: '学生' },
  { value: 11, text: '定年退職' },
  { value: 12, text: '仕事はしていない' },
  { value: 13, text: 'その他' },
]

const generateChannelOptions = (
  channels: ChannelItemOnkarteUserFilteringItemListFragment[]
): FormOptions<FormChannel | null> => {
  return [
    { value: null, text: '指定なし' },
    ...channels.map(channel => ({
      value: channel.id,
      text: channel.name,
    })),
  ]
}

const allPrefectureCodeOptions: FormOptions<Prefecture | null> = [
  { value: null, text: '指定なし' },
  ...PREFECTURE_CODES.map(value => ({
    value: value.id,
    text: value.name,
  })),
]

const generatePrefectureCodeOptions = (
  availableCodes: Prefecture[]
): FormOptions<Prefecture | null> =>
  allPrefectureCodeOptions.filter(
    option => option.value === null || availableCodes.includes(option.value)
  )

const minMillionUnitOptions: FormOptions<MillionUnit | null> = [
  { value: null, text: '下限なし' },
  { value: 1_000_000, text: '100万円から' },
  { value: 2_000_000, text: '200万円から' },
  { value: 3_000_000, text: '300万円から' },
  { value: 4_000_000, text: '400万円から' },
  { value: 5_000_000, text: '500万円から' },
  { value: 6_000_000, text: '600万円から' },
  { value: 7_000_000, text: '700万円から' },
  { value: 8_000_000, text: '800万円から' },
  { value: 9_000_000, text: '900万円から' },
  { value: 10_000_000, text: '1000万円から' },
  { value: 20_000_000, text: '2000万円から' },
  { value: 30_000_000, text: '3000万円から' },
  { value: 40_000_000, text: '4000万円から' },
  { value: 50_000_000, text: '5000万円から' },
  { value: 60_000_000, text: '6000万円から' },
  { value: 70_000_000, text: '7000万円から' },
  { value: 80_000_000, text: '8000万円から' },
  { value: 90_000_000, text: '9000万円から' },
  { value: 100_000_000, text: '1億円から' },
]

const maxMillionUnitOptions: FormOptions<MillionUnit | null> = [
  { value: null, text: '上限なし' },
  { value: 1_000_000, text: '100万円まで' },
  { value: 2_000_000, text: '200万円まで' },
  { value: 3_000_000, text: '300万円まで' },
  { value: 4_000_000, text: '400万円まで' },
  { value: 5_000_000, text: '500万円まで' },
  { value: 6_000_000, text: '600万円まで' },
  { value: 7_000_000, text: '700万円まで' },
  { value: 8_000_000, text: '800万円まで' },
  { value: 9_000_000, text: '900万円まで' },
  { value: 10_000_000, text: '1000万円まで' },
  { value: 20_000_000, text: '2000万円まで' },
  { value: 30_000_000, text: '3000万円まで' },
  { value: 40_000_000, text: '4000万円まで' },
  { value: 50_000_000, text: '5000万円まで' },
  { value: 60_000_000, text: '6000万円まで' },
  { value: 70_000_000, text: '7000万円まで' },
  { value: 80_000_000, text: '8000万円まで' },
  { value: 90_000_000, text: '9000万円まで' },
  { value: 100_000_000, text: '1億円まで' },
]

const minTenThousandUnitOptions: FormOptions<TenThousandUnit | null> = [
  { value: null, text: '下限なし' },
  { value: 10_000, text: '1万円から' },
  { value: 20_000, text: '2万円から' },
  { value: 30_000, text: '3万円から' },
  { value: 40_000, text: '4万円から' },
  { value: 50_000, text: '5万円から' },
  { value: 60_000, text: '6万円から' },
  { value: 70_000, text: '7万円から' },
  { value: 80_000, text: '8万円から' },
  { value: 90_000, text: '9万円から' },
  { value: 100_000, text: '10万円から' },
]

const maxTenThousandUnitOptions: FormOptions<TenThousandUnit | null> = [
  { value: null, text: '上限なし' },
  { value: 10_000, text: '1万円まで' },
  { value: 20_000, text: '2万円まで' },
  { value: 30_000, text: '3万円まで' },
  { value: 40_000, text: '4万円まで' },
  { value: 50_000, text: '5万円まで' },
  { value: 60_000, text: '6万円まで' },
  { value: 70_000, text: '7万円まで' },
  { value: 80_000, text: '8万円まで' },
  { value: 90_000, text: '9万円まで' },
  { value: 100_000, text: '10万円まで' },
]

const emit = defineEmits<{
  (event: 'change', value: KarteUserFilteringRule): void
}>()

const {
  ruleRef,
  favoriteFilteringRulesRef,
  selectedFavoriteFilteringRuleIndex,
  selectedFavoriteFilteringRule,
  loadFavoriteFilteringRule,
  saveFavoriteFilteringRule,
  updateFavoriteFilteringRule,
  removeFavoriteFilteringRule,
} = useKarteUserFilteringRule()

const karteUserFilteringItemListQuery = useKarteUserFilteringItemListQuery()

const hasFavoriteFilteringRules = computed(
  (): boolean => favoriteFilteringRulesRef.value.length > 0
)

const saveFavorite = (label: string) => {
  if (!saveFavoriteFilteringRule(label)) {
    alert.error(`検索条件「${label}」を保存できませんでした`)
    return
  }
  alert.success(`検索条件「${label}」を保存しました`)
}

const updateFavorite = (updatedLabel: string) => {
  const label = selectedFavoriteFilteringRule.value?.label ?? ''
  if (!updateFavoriteFilteringRule(updatedLabel)) {
    alert.error(`検索条件「${label}」を更新できませんでした`)
    return
  }

  if (label !== updatedLabel) {
    alert.success(`検索条件「${label}」を「${updatedLabel}」に更新しました`)
    return
  }
  alert.success(`検索条件「${label}」を更新しました`)
}

const removeFavorite = () => {
  const label = selectedFavoriteFilteringRule.value?.label ?? ''
  if (!removeFavoriteFilteringRule()) {
    alert.error(`検索条件「${label}」を削除できませんでした`)
    return
  }
  alert.success(`検索条件「${label}」を削除しました`)
}

const annualIncomeFilterRule = computed<KarteUserFilteringRule['annualIncome']>(
  () => ({
    min:
      ruleRef.value.annualIncome.min ??
      emptyKarteUserFilteringRule.annualIncome.min,
    max:
      ruleRef.value.annualIncome.max ??
      emptyKarteUserFilteringRule.annualIncome.max,
  })
)

const partnerAnnualIncomeFilterRule = computed<
  KarteUserFilteringRule['partnerAnnualIncome']
>(() => ({
  min:
    ruleRef.value.partnerAnnualIncome.min ??
    emptyKarteUserFilteringRule.partnerAnnualIncome.min,
  max:
    ruleRef.value.partnerAnnualIncome.max ??
    emptyKarteUserFilteringRule.partnerAnnualIncome.max,
}))

const savingFilterRule = computed<KarteUserFilteringRule['saving']>(() => ({
  min: ruleRef.value.saving.min ?? emptyKarteUserFilteringRule.saving.min,
  max: ruleRef.value.saving.max ?? emptyKarteUserFilteringRule.saving.max,
}))

const investmentFilterRule = computed<KarteUserFilteringRule['investment']>(
  () => ({
    min:
      ruleRef.value.investment.min ??
      emptyKarteUserFilteringRule.investment.min,
    max:
      ruleRef.value.investment.max ??
      emptyKarteUserFilteringRule.investment.max,
  })
)

const totalAssetsFilterRule = computed<KarteUserFilteringRule['totalAssets']>(
  () => ({
    min:
      ruleRef.value.totalAssets.min ??
      emptyKarteUserFilteringRule.totalAssets.min,
    max:
      ruleRef.value.totalAssets.max ??
      emptyKarteUserFilteringRule.totalAssets.max,
  })
)

const monthlyInsuranceFeeFilterRule = computed<
  KarteUserFilteringRule['monthlyInsuranceFee']
>(() => ({
  min:
    ruleRef.value.monthlyInsuranceFee.min ??
    emptyKarteUserFilteringRule.monthlyInsuranceFee.min,
  max:
    ruleRef.value.monthlyInsuranceFee.max ??
    emptyKarteUserFilteringRule.monthlyInsuranceFee.max,
}))

const loanBalanceFilterRule = computed<KarteUserFilteringRule['loanBalance']>(
  () => ({
    min:
      ruleRef.value.loanBalance.min ??
      emptyKarteUserFilteringRule.loanBalance.min,
    max:
      ruleRef.value.loanBalance.max ??
      emptyKarteUserFilteringRule.loanBalance.max,
  })
)

const generationRule = computed<KarteUserFilteringRule['generation']>(() =>
  ruleRef.value.generation.map(value => ({
    min: value,
    max: value === 0 ? 29 : value === 60 ? Number.MAX_SAFE_INTEGER : value + 9,
  }))
)

const sexRule = computed(() => {
  if (ruleRef.value.sex === 'male') {
    return 'male'
  }
  if (ruleRef.value.sex === 'female') {
    return 'female'
  }
  return emptyKarteUserFilteringRule.sex
})

const defineBoolRule = <K extends keyof KarteUserFilteringRuleForm>(
  ruleKey: K,
  option: { true: string; false: string; empty: boolean | null }
) =>
  computed(() => {
    const value = ruleRef.value[ruleKey]
    if (value === option.true) {
      return true
    }
    if (value === option.false) {
      return false
    }
    return option.empty
  })

const partnerRule = defineBoolRule('partnerExistence', {
  true: 'existPartner',
  false: 'noPartner',
  empty: emptyKarteUserFilteringRule.hasPartner,
})
const childRule = defineBoolRule('childrenExistence', {
  true: 'existChildren',
  false: 'noChildren',
  empty: emptyKarteUserFilteringRule.hasChild,
})
const answeredRule = defineBoolRule('hasAnswered', {
  true: 'answered',
  false: 'notAnswered',
  empty: emptyKarteUserFilteringRule.hasAnswered,
})
const concernRule = defineBoolRule('hasConcern', {
  true: 'existConcern',
  false: 'noConcern',
  empty: emptyKarteUserFilteringRule.hasConcern,
})

const planner = computed<Planner | undefined>(() => {
  const data = karteUserFilteringItemListQuery.result?.value?.planner
  const allSpecialty =
    karteUserFilteringItemListQuery.result?.value?.specialties || []
  if (data) {
    return parsePlannerProfileResponseToPlanner(
      {
        ...data,
        id: parseInt(data.id),
        corporationId: parseInt(data.corporationId),
        branchIds: data.branchIds.map(id => parseInt(id)),
        specialties: data.specialties.map(specialty => specialty.name),
      },
      allSpecialty.map(specialty => ({
        ...specialty,
        id: parseInt(specialty.id),
      }))
    )
  }
  return undefined
})

const prefectureCodeOptions = computed(() =>
  generatePrefectureCodeOptions(planner.value?.availablePrefectureCodes ?? [])
)

const prefecture = computed(() => {
  if (!ruleRef.value.prefecture) {
    return undefined
  }

  return convertJisx0402CodeToGqlPrefecture(ruleRef.value.prefecture)
})

const fetchCities = useFetchCitiesOnKarteUserFilterItemListQuery(
  () => ({
    prefecture: prefecture.value as PrefectureSchema,
  }),
  () => ({ enabled: !!prefecture.value })
)

const cityOptions = computed<FormOptions<string | null>>(() => {
  if (ruleRef.value.prefecture == undefined) {
    return []
  }

  const cities = fetchCities.result.value?.getCitiesByPrefecture ?? []

  const opts = cities.map(c => ({
    text: c.name,
    value: c.jisx0402,
  }))

  const empty: FormOptions<string | null>[number] = {
    text: '指定なし',
    value: null,
  }

  return [empty, ...opts]
})

const channelOptions = computed(() => {
  return generateChannelOptions(
    karteUserFilteringItemListQuery.result.value?.viewer.channels ?? []
  )
})

const filteringRule = computed<KarteUserFilteringRule>(() => ({
  annualIncome: annualIncomeFilterRule.value,
  partnerAnnualIncome: partnerAnnualIncomeFilterRule.value,
  saving: savingFilterRule.value,
  investment: investmentFilterRule.value,
  totalAssets: totalAssetsFilterRule.value,
  monthlyInsuranceFee: monthlyInsuranceFeeFilterRule.value,
  loanBalance: loanBalanceFilterRule.value,
  generation: generationRule.value,
  prefecture: ruleRef.value.prefecture,
  city: ruleRef.value.city,
  sex: sexRule.value,
  hasPartner: partnerRule.value,
  hasChild: childRule.value,
  hasAnswered: answeredRule.value,
  hasConcern: concernRule.value,
  channel: ruleRef.value.channel,
  jobIds: ruleRef.value.jobIds,
}))

watch(partnerRule, () => {
  ruleRef.value.partnerAnnualIncome.min = null
  ruleRef.value.partnerAnnualIncome.max = null
})

watch(
  () => [ruleRef.value.prefecture, ruleRef.value.city],
  (value, oldValue) => {
    // 市区町村が同じで都道府県が違うときのみ市区町村をクリアする
    //
    // これは都道府県の選択時に、市区町村をクリアするためであり、
    // localStorage からの検索条件の復元など 都道府県・市区町村どちらも変更されたときに市区町村をクリアしないためである
    if (value[0] !== oldValue[0] && value[1] === oldValue[1]) {
      ruleRef.value.city = null
    }
  }
)

watch(
  filteringRule,
  (value, oldValue) => {
    if (fastDeepEqual(value, oldValue)) {
      return
    }
    emit('change', value)
  },
  { immediate: true }
)
</script>

<style lang="scss" module>
.list {
  display: grid;
  background-color: $color-surface-primary;
  border-radius: $border-radius-v2-rounder;

  &__contents {
    padding: 12px 0;
    overflow-y: scroll;

    &:nth-child(n + 2) {
      border-top: 1px solid $color-border-low-emphasis;
    }
  }
}

.header {
  padding: 24px;

  &__title {
    margin-right: auto;
    font-size: 16px;
    font-weight: bold;
  }
}

.content {
  $root: &;

  &__item {
    padding: 10px 24px;
  }

  &__text {
    padding: 0 0 8px;
    font-size: 14px;
    font-weight: bold;

    #{$root}--disabled & {
      color: $color-text-and-object-low-emphasis;
    }
  }

  &__selector {
    width: 100%;
  }

  &__range {
    width: 100%;
  }
}

.titleWithHelp {
  display: flex;
  align-items: center;

  &__help {
    transform: translateY(-2px);

    &:nth-child(n + 2) {
      margin-left: 8px;
    }
  }
}

.tip {
  min-width: 120px;
}

.selectable {
  display: inline-flex;
  align-items: center;

  &__text {
    &:nth-child(n + 2) {
      padding-left: 4px;
    }
  }
}

.nocomment {
  display: inline-flex;
  padding-top: 8px;

  &__text {
    flex: 1;

    &:nth-child(n + 2) {
      padding-left: 4px;
    }
  }
}

.radiobutton {
  &:nth-child(n + 2) {
    padding-top: 8px;
  }
}

.address {
  &__city {
    margin-top: 8px;
  }
}
</style>
